export let config: any = {};